import { create } from 'zustand'
import moment from 'moment'
import { parseStartDateAsUTC, parseEndDateAsUTC } from '../../server/utils/date'

const VIEW_PERIOD_DAY = 'day'
const VIEW_PERIOD_WEEK = 'week'

export { VIEW_PERIOD_DAY, VIEW_PERIOD_WEEK }

export const getUIRefreshTimePeriod = ({ selectedDate, viewPeriod }) => {
  const date = moment(selectedDate)
  const isDay = viewPeriod === VIEW_PERIOD_DAY

  if (isDay) {
    return {
      startISO: parseStartDateAsUTC(date.clone().startOf('day')),
      endISO: parseEndDateAsUTC(date.clone().endOf('day')),
    }
  }

  return {
    startISO: parseStartDateAsUTC(
      date
        .clone()
        .weekday(1)
        .subtract(1, 'day')
        .startOf('day'),
    ),
    endISO: parseEndDateAsUTC(
      date
        .clone()
        .weekday(7)
        .subtract(1, 'day')
        .endOf('day'),
    ),
  }
}

const useCalendarUIStore = create(set => ({
  currentEditableEntry: {},
  clearCurrentEditableEntry: () => set({ currentEditableEntry: {} }),
  pendingEntryIds: new Set(),
  addPendingEntryId: id => set(s => ({ pendingEntryIds: new Set([...s.pendingEntryIds, id]) })),
  removePendingEntryId: id =>
    set(s => {
      const next = new Set(s.pendingEntryIds)
      next.delete(id)
      return { pendingEntryIds: next }
    }),
}))

export default useCalendarUIStore
